import { SET_MATCHED_PROTOCOLS } from '../actions/protocolActions';

const initialState = {
  matchedProtocols: [],
};

const protocolReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_MATCHED_PROTOCOLS:
      console.log('🔍 [HP Debug] Reducer SET_MATCHED_PROTOCOLS payload:', action.payload);
      return {
        ...state,
        matchedProtocols: action.payload,
      };
    default:
      return state;
  }
};

export default protocolReducer;
